"use client";

import { BrainIcon } from "lucide-react";

import type { ThinkingContentBlock } from "../../types";
import { truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

interface ThinkingBlockProps {
  block: ThinkingContentBlock;
  isStreaming?: boolean;
}

export const ThinkingBlock = ({ block, isStreaming }: ThinkingBlockProps) => {
  if (!block.thinking && !isStreaming) {
    return null;
  }

  const preview = truncate(block.thinking);

  return (
    <CollapsibleSection
      icon={<BrainIcon className="h-3 w-3" />}
      label="Thinking"
      preview={preview}
      copyContent={block.thinking}
      isStreaming={isStreaming}
    >
      <p className="whitespace-pre-wrap text-xs text-zinc-600">
        {block.thinking}
      </p>
    </CollapsibleSection>
  );
};
